<template>
  <v-form
    ref="formContactUs"
    lazy-validation
     >
    <v-dialog
      max-width="1000px"
      v-model="dialogContactUs"
      transition="scale-transition" persistent
      @keydown.esc="setViewDialogContactUs(false)" >
      <v-card>
        <v-toolbar card dark color="primary" >
          <v-toolbar-title>Contact us</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon dark @click="setViewDialogContactUs(false)">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-alert dismissible v-if="show_error_message" :value="show_error_message" type="error" >{{ show_error_message }}</v-alert>
          <v-layout  v-if="!authenticated">
            <v-flex xs12 md6 class="px-2">
              <v-text-field v-model="values.firstname" :counter="60" label="Firstname" name="firstname"
                :rules="[rules.required]" />
            </v-flex>
            <v-flex xs12 md6 class="px-2">
              <v-text-field v-model="values.lastname" :counter="60" label="Lastname" name="lastname"
                :rules="[rules.required]" />
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex md12 class="px-2">
              <v-text-field v-if="!authenticated" v-model="values.email" :counter="60" label="Email"  name="email"
                :rules="[rules.required, rules.email]"
                data-vv-name="email"
                :error-messages="errors.collect('email')"
                v-validate="'required'"
                required />
              <v-text-field v-model="values.phone" :counter="20" label="Phone" name="phone" />
              <v-text-field v-if="!authenticated" v-model="values.company_name" :counter="120" label="Company name" name="company"
                :rules="[rules.required]"
                data-vv-name="company_name"
                :error-messages="errors.collect('company_name')"
                v-validate="'required'" />
              <v-checkbox v-if="!authenticated" v-model="values.tfwa_member" label="My company is a TFWA member"></v-checkbox>
            </v-flex>
          </v-layout>
          <br />
          <v-textarea
            label="Write us a message here"
            v-model="values.comment"
            box
            auto-grow >
          </v-textarea>

        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click.native="setViewDialogContactUs(false)">Cancel</v-btn>
            <v-btn color="blue darken-1" flat @click.native="contactUsSend()">Send</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-form>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import NEW_SUBSCRIPTION from '@/graphql/NewSubscription.gql'

export default {
  name: 'AccessPage',
  data () {
    return {
      default_values: {
        'type': '',
        'user_sub': '',
        'lastname': '',
        'firstname': '',
        'email': '',
        'company_name': '',
        'tfwa_member': false,
        'comment': '',
        'phone': '',
      },
      values: {
        'type': '',
        'user_sub': '',
        'lastname': '',
        'firstname': '',
        'email': '',
        'company_name': '',
        'tfwa_member': false,
        'comment': '',
        'phone': '',
      },
      show_error_message: null,
      dictionary: {
        custom: {
          email: {
            required: () => 'Email can not be empty'
          },
          company_name: {
            required: () => 'Company name can not be empty'
          }
        }
      },
      show_password: false,
      rules: {
        required: value => !!value || 'Required.',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      },
    }
  },
  computed: {
    ...mapState(['dialogContactUs', 'authenticated', 'userProfile']),
  },
  methods: {
    ...mapMutations(['setViewDialogContactUs']),
    async contactUsSend () {
      if (!this.$refs.formContactUs.validate()) {
        return
      }
      let check = await this.$validator.validateAll()
      if (!check) { return }

      this.values.type = 'ContactUsAccessPage'
      if (this.authenticated) {
        this.values.user_sub = this.userProfile.sub
      }
      this.values.searchEngineUserQuantity = parseInt(this.user_searchengine)
      this.values.wikiUserQuantity = parseInt(this.user_wiki)

      this.$apollo.mutate({
        mutation: NEW_SUBSCRIPTION,
        variables: {
          new_subscription: this.values
        }
      }).then((data) => {
        // TODO: refactore to use something similar than the errors_info state
        if (!(data !== undefined && data.data !== undefined && data.data.newSubscription.statusCode === undefined)) {
          this.show_error_message = `An error appeared when trying to send your request: \n${data.data.newSubscription.message}`
          return
        }
        this.setViewDialogContactUs(false)
        this.values = Object.assign({}, this.default_values)
      })
    },
  }
}
</script>
<style>
.documentDialog .documentDialog_title{
  white-space: normal;
  -webkit-box-shadow: 0 2px 4px -1px rgba(0,0,0,.2), 0 4px 5px 0 rgba(0,0,0,.14), 0 1px 10px 0 rgba(0,0,0,.12);
  box-shadow: 0 2px 4px -1px rgba(0,0,0,.2), 0 4px 5px 0 rgba(0,0,0,.14), 0 1px 10px 0 rgba(0,0,0,.12);
  position: relative;
  -webkit-transition: none;
  transition: none;
  width: 100%;
  will-change: padding-left,padding-right;
  color: #fff;
  font-size: 18px;
  font-weight: 500;
  letter-spacing: .02em;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0px 14px;
}
.documentDialog .documentDialog_title p {
  margin-top: 11px;
  margin-bottom: 3px;
}
</style>
